import { useBreakLG } from "@monta/design-system";
import { DescriptiveQuestionBody as DqBody } from "./Body";
import { CorrectAnswerDescription as DqAnswer } from "./CorrectAnswerDescription";
import styles from "./dq.module.scss";
import { DescriptiveQuestionFooter as DqFooter } from "./Footer";
import { DescriptiveQuestionHeader as DqHeader } from "./Header";
import { DescriptiveQuestionSidebar as DqSidebar } from "./Sidebar";
import type { DqGlobalProps } from "./types";

const DescriptiveQuestion = (props: DqGlobalProps) => {
  const { id, shouldRenderAs = "default" } = props;
  const isLG = useBreakLG();

  return (
    <article className={styles["dq-container"]}>
      <section className={styles["dq-container__top-section"]}>
        <section
          className={styles["dq-container__top-section__header-body-container"]}
        >
          <DqHeader id={id} />
          <DqBody id={id} />
        </section>
        {isLG && <DqSidebar id={id} />}
      </section>
      <DqFooter
        id={id}
        shouldRenderAs={shouldRenderAs}
        answerComponent={<DqAnswer id={id} />}
      />
    </article>
  );
};

export default DescriptiveQuestion;
